module.exports = __webpack_public_path__ + "assets/img/jujiao.eb736bf0.png";